<div class="release-notes-popup">
  <div class="release-notes-popup-header d-flex justify-content-between align-items-start">
    <div>
      <h5 class="mb-1">New Features!</h5>
      <p class="text-muted mb-0">You have unread release notes available.</p>
    </div>
    <button mat-icon-button class="close-button" (click)="close()" aria-label="Close release notes popup">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="release-notes-popup-body">
    <div class="release-note-link" *ngFor="let note of data.releaseNotes" (click)="openReleaseNote(note)">
      <div class="release-note-title">{{note.title}}</div>
      <div class="release-note-date">Published {{note.publishedAt | date:'MMM d, y h:mm a'}}</div>
    </div>
  </div>

  <div class="release-notes-popup-footer text-end">
    <button mat-stroked-button color="primary" (click)="close()">Close</button>
  </div>
</div>
